import { ChangeEvent, useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { Button, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import "../components/styles/UploadFaxFile.css";
import Api_Call from "../ApiCall";
import menus from "../info.json";
const UploadFaxFile = () => {
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [fileLimit, setFileLimit] = useState(false);
  const [listFiles, setListFiles] = useState();
  //const uploaded = [...uploadedFiles];
  let uploaded = [];

  // Dev URL
  //const baseurl_faxupload = "https://tokcfhkksh.execute-api.us-east-1.amazonaws.com/Dev/vcare_faxupload";
  //const baseurl_checkduplicate = "https://tokcfhkksh.execute-api.us-east-1.amazonaws.com/Dev/vcare_duplicatefile";
  // QA URL
  // const baseurl_faxupload = "https://63japqerd7.execute-api.us-east-1.amazonaws.com/Demo/zone2_vcare_faxupload";
  // const baseurl_checkduplicate = "https://63japqerd7.execute-api.us-east-1.amazonaws.com/QA/zone2_vcare_duplicatefile";
  // Demo URL
  //const baseurl_faxupload = "https://g934ehp5bj.execute-api.us-east-1.amazonaws.com/demo/demo_vcare_faxupload";
  //const baseurl_checkduplicate = "https://g934ehp5bj.execute-api.us-east-1.amazonaws.com/demo/demo_vcare_duplicatefile";

  const handleUploadFiles = (files) => {
    console.log("type ", files);
    // const uploaded = [...uploadedFiles];
    //console.log(files);
    const fileList = Array.prototype.slice.call(files);
    //console.log(' list of files ', fileList);
    let result = FileExistWrapper(fileList, files);
    console.log(result);
    return;
  };

  const UploadAPICall = async (data) => {
    try {
      const api = new Api_Call();
      const response = await api.postData(
        "FILE/UPLOAD",
        data,
        menus.BASE_URL_ADMIN
      );
      let isStatus = response.headers.success;
      console.log(isStatus);
      if (isStatus === true) {
        toast.success(response.body, { autoClose: true });
      } else {
        toast.error(response.body, { autoClose: true });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const OnFileUpload = (selectedFile) => {
    return new Promise((resolve) => {
      let fileInfo;
      let reader = new FileReader();
      let res = "default";
      const date = new Date();
      const today_date = _formatTheDate(date);
      // Convert the file to base64 text
      reader.readAsDataURL(selectedFile);
      reader.onload = () => {
        console.log("Called", reader);
        console.log(reader.result);
        res = reader.result;
        let res1 = res.split(",")[1];
        console.log("result ", res1);
        UploadAPICall({
          fax_data: res1,
          file: selectedFile.name,
          date: today_date,
        });
      };
      console.log(fileInfo);
    });
  };

  async function CheckFileonS3(data) {
    console.log("data in axios call ", data);

    try {
      const api = new Api_Call();
      const response = await api.postData(
        "FILE/DUPLICATE-CHECK",
        { files: data },
        menus.BASE_URL_ADMIN
      );
      let isStatus = response.headers.success;
      console.log(isStatus);
      if (isStatus === true) {
        toast.success(response.body.msg, { autoClose: true });
      } else {
        toast.error(response.body.msg, { autoClose: true });
      }
    } catch (error) {
      console.log(error);
    }
  }

  const FileExistWrapper = (filelist, files) => {
    let file_arr = [];
    for (const file of filelist) {
      file_arr.push(file.name);
    }
    // let status = CheckFileonS3( file_arr );
    CheckFileonS3(file_arr).then((response) => {
      console.log("response from wrapper ", response);
      //return response;
      if (response === true) {
        console.log("Disable the button for upload");
        setFileLimit(true);
      } else {
        console.log("Enable the button for upload");
        setFileLimit(false);
        //SendFiletoS3(files);
      }
    });
  };

  const _formatTheDate = (dateParam) => {
    const yyyy = dateParam.getFullYear();
    let mm = dateParam.getMonth() + 1; // Months start at 0!
    let dd = dateParam.getDate();
    if (dd < 10) dd = "0" + dd;
    if (mm < 10) mm = "0" + mm;
    const formattedDate = mm + "-" + dd + "-" + yyyy;
    return formattedDate;
  };

  const SendFiletoS3 = () => {
    console.log("files in send function ", listFiles);
    let limitExceeded = false;
    uploaded = [...uploadedFiles];
    listFiles.some((file) => {
      console.log(file);
      OnFileUpload(file);
      console.log(file);
      if (uploaded.findIndex((f) => f.name === file.name) === -1) {
        uploaded.push(file);
      }
    });
    setListFiles([]);
    setUploadedFiles([]);
    if (!limitExceeded) setUploadedFiles(uploaded);
  };

  // function UploadFaxFile() {
  //   const [uploadedFiles, setUploadedFiles] = useState([]);
  //   const [fileLimit, setFileLimit] = useState(false);

  //   const handleUploadFiles = files => {
  //     const uploaded = [...uploadedFiles];
  //     //console.log(files);
  //     const fileList = Array.prototype.slice.call(files);
  //     //console.log(' list of files ', fileList);
  //     let result = FileExistWrapper(fileList, files);
  //     console.log(result);
  //     return;
  //   };

  const handleFileEvent = (e) => {
    const chosenFiles = Array.prototype.slice.call(e.target.files);
    console.log("chosen files ", chosenFiles);
    setListFiles(chosenFiles);
    console.log("files list ", listFiles);
    handleUploadFiles(chosenFiles);
  };

  return (
    <>
      <Box className="faxUpload-container">
        <Typography variant="h4">Upload PDF</Typography>
        <table>
          <th>
            <td>
              <input
                id="fileUpload"
                type="file"
                multiple
                accept="application/pdf"
                onChange={handleFileEvent}
                disabled={fileLimit}
              />
            </td>
            <td>
              <Button
                variant="contained"
                disabled={fileLimit}
                onClick={SendFiletoS3}
              >
                Upload!
              </Button>
            </td>
          </th>
        </table>
        <div>
          <ol>
            {uploaded.map((file) => (
              <li key={file}>{file.name}</li>
            ))}
          </ol>
        </div>
      </Box>
    </>
  );
};
export default UploadFaxFile;
